export default __webpack_public_path__ + "static/media/E4.de9b7968.jpg";